<template>
    <div class="max-width-content">
        <breadcrumbs>
            <inertia-link :href="route('admin.blogcategories.index')">Blogrubrieken</inertia-link>
            <i class="fad fa-chevron-right"></i>
            Nieuwe rubriek
        </breadcrumbs>

        <div class="mt-5 bg-white rounded-lg px-8 py-5">
            <tag-form @submit="submit" :categories="categories" :data-loading="loading"></tag-form>
        </div>
    </div>
</template>

<script>
import Layout from "@/admin/Shared/Layout";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";
import TagForm from "@/admin/Pages/BlogCategory/BlogCategoryForm";

export default {
    metaInfo() {
        return { title: "Nieuwe tag" };
    },

    layout: (h, page) => h(Layout, [page]),

    components: {
        Breadcrumbs,
        TagForm
    },

    mixins: [Helpers],

    props: {
        categories: Array
    },

    data() {
        return {};
    },

    methods: {
        submit(data) {
            this.loading = "submit";
            const url = this.route("admin.blogcategories.store");
            const options = {
                onSuccess: () => this.loading = false,
                onError: () => this.loading = false
            }
            this.$inertia.post(url, data, options)
        }
    }
};
</script>
